import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestExtractionsQueryKey } from "../bond-request.keys";

type UseFetchBondRequestExtractionsParams = {
	accountId: SuretyAccountId;
	quoteId: SuretyQuoteId;
	enabled?: boolean;
};

export const useFetchBondRequestExtractions = ({
	accountId,
	quoteId,
	enabled = true,
}: UseFetchBondRequestExtractionsParams) => {
	const { get } = useRequest();

	const { data } = useQuery({
		queryKey: bondRequestExtractionsQueryKey(quoteId),
		queryFn: () =>
			get<Dtos.BondRequestExtraction.List.Response>(
				`/v2/surety/accounts/${accountId}/quotes/${quoteId}/bond-request-extractions`,
			),
		enabled,
	});

	return { extractions: data };
};
